import Module from '../../utils/modules/Module';
import EventsManager from '../../utils/events/EventsManager';
import CustomEvents from '../../utils/events/CustomEvents';

export default class ListModule extends Module {
  constructor(options) {
    super(options)

    this.DOMEl = this.options.element;
    this.id = this.options.id;

    this.onClickOpen = this.onClickOpen.bind(this);
    this.onClickClose = this.onClickClose.bind(this);
    this.handleClickOut_bind = this.handleClickOut.bind(this);
    this.onClickClose_bind = this.onClickClose.bind(this);
    this.onScrollIn_bind = this.onScrollIn.bind(this);

    this.lastScrollTop = 0;
    this.fullTitle = "";

    this.DOMEl.addEventListener('click', (ev) => {
      if(ev.target.matches('.list-item:not(.presentation-item):not(.list-item-panel)') ||
         ev.target.matches('.list-item.presentation-item.presentation-modal') ||
         ev.target.matches('button.btn-simple') ||
         ev.target.matches('button.list-btn')) {
        this.onClickOpen(ev);
      }
    });

    this.init();
  }

  init() {
    EventsManager.on(CustomEvents.search.UPDATE_FILTERS, this.refreshList.bind(this));
    this.refreshList();
  }


  /** ------------------------------
   * Events
   --------------------------------- */
  onClickOpen(e) {
    e.preventDefault();

    let $el = e.target;
    let $section = document.querySelectorAll('.list-wrapper');
    let $parent = $el.closest('.list-item-wrapper');
    let $panel = $parent.querySelector('.panel');
    $panel.classList.remove('no-trans', 'hide-reader');
    $panel.setAttribute('aria-expanded', true);
    $panel.classList.add('open');
    $section.forEach(el => {
      el.classList.add('open');
    });

    // animations
    document.querySelector('html').classList.add('no-scroll', 'shadow', 'fadeIN');
    setTimeout(function () {
      document.querySelector('html').classList.remove('fadeIN');
      $panel.querySelector('.panel-btn').focus();
    }, 600);

  }



  onClickClose() {
    let $panels = document.querySelectorAll('.panel');
    let $section = document.querySelectorAll('.list-wrapper');

    $section.forEach(el => {
      el.classList.remove('open');
    });

    $panels.forEach(el => {
      el.classList.remove('open');
      el.setAttribute('aria-expanded', false);
    });
    document.querySelector('html').classList.add('fadeOUT');

    setTimeout(function () {
      $panels.forEach(el => {
        el.classList.add('hide-reader');
      });
      document.querySelector('html').classList.remove('no-scroll', 'shadow', 'fadeOUT');
    }, 600);
  }



  onScrollIn(e) {
    let self = this,
        $main = e.target,
        $panel = $main.closest('.panel'),
        $head = $panel.querySelector('.panel-head'),
        $title = $panel.querySelector('.panel-head-inner'),
        st = $main.scrollTop,
        headerH = $panel.querySelector('.panel-head').clientHeight;
    $panel.style.setProperty('--space-top', headerH + 'px');

    // downscroll
    if (st > this.lastScrollTop) {
      if (st < 8) {
        $panel.classList.add('scrolled');
        $title.classList.add('fadeTx');
        $main.classList.add('no-scroll');

        setTimeout(function () {
          $head.classList.add('scrolled');
          $panel.querySelector('.panel-title').innerHTML = $panel.querySelector('.panel-title').dataset.trimmed;
        }, 350);

        setTimeout(function () {
          $title.classList.remove('fadeTx');
          $main.classList.remove('no-scroll');
        }, 600);
      }
    }

    // upscroll
    else {
      setTimeout(function () {
      if (st < 8 && $main.clientHeight > (window.innerHeight - (headerH + 120))) {
        $panel.classList.remove('scrolled');
        $title.classList.add('fadeTx');

        setTimeout(function () {
          $head.classList.remove('scrolled');
          $panel.querySelector('.panel-title').innerHTML = $panel.querySelector('.panel-title').dataset.full;
        }, 350);

        setTimeout(function () {
          $title.classList.remove('fadeTx');
        }, 600);
      }
      }, 610);
    }

    setTimeout(function () {
      headerH = $panel.querySelector('.panel-head').clientHeight;
      $panel.style.setProperty('--space-top', headerH + 'px');
    }, 600);

    this.lastScrollTop = st <= 0 ? 0 : st;
  }



  handleClickOut(e) {
    if(document.querySelector('html').classList.contains('shadow')) {
      // click outside
      if (e.target.classList.contains('shadow')){
        this.onClickClose_bind();
      }
      // press escape key
      if (e.keyCode === 27) {
        this.onClickClose_bind();
      }
    }
  }

  /**
   * The real init method
   * Used on load AND after an ajax call due to a search
   */
  refreshList() {
    // ----------- Close multiple ways ----------- //
    document.querySelectorAll('.panel-btn').forEach((el) => {
      el.addEventListener('click', this.onClickClose);
    });
    document.addEventListener('click', this.handleClickOut_bind);
    document.addEventListener('keydown', this.handleClickOut_bind);

    // ----------- Panel content ----------- //
    this.DOMEl.querySelectorAll('.panel-main').forEach((el) => {
      // setup space for panel's header
      let panel = el.closest('.panel');
      let close = panel.querySelector('.panel-btn');
      let headerH = panel.querySelector('.panel-head').clientHeight;
      panel.style.setProperty('--space-top', headerH + 'px');

      // setup link into simple button
      if (el.querySelectorAll('a').length !== 0) {
        el.querySelectorAll('a').forEach((e) => {
          e.classList.add('btn-simple');
        });
      }

      // Prep title if too long
      let int = 25;
      this.title = panel.querySelector('.panel-title');
      this.title.classList.contains('long') ? int = 55: int = 25;
      this.fullTitle = this.title.innerHTML;
      this.trimmedTitle = this.fullTitle.length > int ? this.fullTitle.substring(0, int) + " [...]" : this.fullTitle;
      this.title.setAttribute('data-full', this.fullTitle);
      this.title.setAttribute('data-trimmed', this.trimmedTitle);

      // events
      el.addEventListener('scroll', this.onScrollIn_bind);

      // accessibility
      let last = document.createElement("span");
      last.classList.add('screen-reader-only', 'panel-last');
      last.setAttribute('tabindex', '0');
      last.setAttribute('aria-hidden', 'true');
      panel.append(last);

      last.addEventListener('focus', function () {
        close.focus();
      });

      close.addEventListener('focusout', function () {
        el.focus();
      });
    });

    // ----------- Hide / block on resize ----------- //
    window.addEventListener('resize', function () {
      document.querySelectorAll('.panel').forEach((el) => {
        el.classList.add('no-trans');
      });
    });
  }

}
